import moment from "moment";
import Translator from "utils/translator";

if (Translator.locale !== "en") {
    import(`moment/locale/${Translator.locale}`);
}

moment.locale(Translator.locale);

export default moment;
